import { gql } from 'graphql-request';
import { useQuery } from '@tanstack/react-query';
import AppError from '../../../../app/features/error/services/AppError';
import useGraphQLClient from '../../../../app/hooks/useGraphQLClient';
import { useAuthContext } from '../../../auth/contexts/AuthContext';
import IInvestExpertiseFilters from '../../interfaces/expertise/IInvestExpertiseFilters';
import IFundTypeHistoryFlow from '../../interfaces/expertise/history/IFundTypeHistoryFlow';
import { useAppNavigationContext } from '../../../../app/features/navigation/providers/AppNavigationProvider';

const useInvestExpertiseHistoryFlows = (filters: IInvestExpertiseFilters) => {
	const auth = useAuthContext();
	const navigationContext = useAppNavigationContext();
	const graphQLClient = useGraphQLClient();
	const filter = {
		typeTag: filters.typeTag,
		fundIds: filters.fundIds,
		investorIds: filters.investorIds,
		currency: navigationContext.currentCurrency,
	};
	const { data } = useQuery(
		['fundTypeHistoryFlows', filter],
		async () => {
			try {
				const data = (await graphQLClient.request(
					gql`
						query ($typeTag: String, $fundIds: [Int], $currency: String, $investorIds: [Int]) {
							fundTypeHistoryFlows(
								typeTag: $typeTag
								fundIds: $fundIds
								currency: $currency
								investorIds: $investorIds
							) {
								funds {
									date
									period {
										year
										quarter
										name
									}
									fundId
									typeTag
									amount
									currency
									investorId
								}
							}
						}
					`,
					filter,
				)) as { fundTypeHistoryFlows: IFundTypeHistoryFlow };
				return data.fundTypeHistoryFlows;
			} catch (e) {
				throw new AppError(e, 'useInvestExpertiseHistoryFlows');
			}
		},
		{
			enabled:
				!!filter.fundIds &&
				auth.currentCompany !== null &&
				auth.isInvestor === true &&
				auth.isAuthenticated &&
				navigationContext.currentCurrency !== null,
		},
	);
	return data ?? null;
};

export default useInvestExpertiseHistoryFlows;
